import { AgentType } from "build-ts/agent";
import { DarwinToolType } from "build-ts/darwin_agent";
import { DarwinAgentType } from "build-ts/common";
import { ReasoningEffortLevel } from "build-ts/agent_config";

// Model options with their corresponding types
export const modelOptions = {
  openai: [
    {
      model_name: "gpt-4o", model_options: {
        reasoning: []
      }
    },
    {
      model_name: "gpt-5", model_options: {
        reasoning: [
          ReasoningEffortLevel.MINIMAL,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH
        ]
      }
    },
    {
      model_name: "gpt-5-mini", model_options: {
        reasoning: [
          ReasoningEffortLevel.MINIMAL,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH
        ]
      }
    },
    {
      model_name: "gpt-5-pro", model_options: {
        reasoning: [
          ReasoningEffortLevel.MINIMAL,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH
        ]

      }
    },
    {
      model_name: "gpt-5-nano", model_options: {
        reasoning: [
          ReasoningEffortLevel.MINIMAL,
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH
        ]

      }
    },
    {
      model_name: "gpt-5.1", model_options: {
        reasoning: [
          ReasoningEffortLevel.NONE,
          // MINIMAL is unsupported in 5.1 - NONE can be used instead
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH
        ]

      }
    },
    {
      model_name: "gpt-5.2", model_options: {
        reasoning: [
          ReasoningEffortLevel.NONE,
          // MINIMAL is unsupported in 5.2 - NONE can be used instead
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
          ReasoningEffortLevel.XHIGH,
        ]

      }
    },
    {
      model_name: "o3-pro", model_options: {
        reasoning: [
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ]
      }
    },
    {
      model_name: "o4-mini", model_options: {
        reasoning: [
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ]
      }
    },
    {
      model_name: "o3", model_options: {
        reasoning: [
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ]
      }
    },
    {
      model_name: "o3-mini", model_options: {
        reasoning: [
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ]
      }
    },
    {
      model_name: "o1", model_options: {
        reasoning: [
          ReasoningEffortLevel.LOW,
          ReasoningEffortLevel.MEDIUM,
          ReasoningEffortLevel.HIGH,
        ]
      }
    }
  ],
  anthropic: [
    { model_name: "claude-opus-4-1-20250805", model_options: {} },
    { model_name: "claude-opus-4-20250514", model_options: {} },
    { model_name: "claude-sonnet-4-20250514", model_options: {} },
    { model_name: "claude-3-7-sonnet-20250219", model_options: {} },
    { model_name: "claude-3-5-haiku-20241022", model_options: {} },
    { model_name: "claude-3-haiku-20240307", model_options: {} },
  ],
  google_genai: [
    { model_name: "gemini-2.0-flash", model_options: {} },
    { model_name: "gemini-2.0-flash-preview", model_options: {} },
    { model_name: "gemini-1.5-pro", model_options: {} },
    { model_name: "gemini-1.5-flash", model_options: {} },
    { model_name: "gemini-1.0-pro", model_options: {} }
  ],
  deepseek: [
    { model_name: "deepseek-chat", model_options: {} },
    { model_name: "deepseek-coder", model_options: {} },
    { model_name: "deepseek-r1", model_options: {} },
    { model_name: "deepseek-v3", model_options: {} }
  ]
};

export const getAgentTypeColorForEva = (type: AgentType | undefined) => {
  switch (type) {
    case AgentType.TIGA:
      return "blue";
    case AgentType.PLAN:
      return "orange";
    case AgentType.TISA_V2:
      return "teal";
    case AgentType.TISA_CONTEXTUALISATION:
      return "red";
    case AgentType.TISA_CHAT:
      return "green";
    case AgentType.TISA_SCENARIO:
      return "yellow";
    default:
      return "gray";
  }
};

export const getAgentTypeColorForDarwinEva = (type: DarwinAgentType | undefined) => {
  switch (type) {
    case DarwinAgentType.SCENARIO_SYNTHESIS_AGENT:
      return "blue";
    case DarwinAgentType.DATA_SCOPE_AGENT:
      return "green";
    case DarwinAgentType.SCENARIO_AGENT:
      return "yellow";
    case DarwinAgentType.ANALYST_CHAT_AGENT:
      return "purple";
    default:
      return "gray";
  }
};

export const getToolTypeColorForDarwinEva = (type: DarwinToolType | undefined) => {
  switch (type) {
    case DarwinToolType.AGENT_TOOL:
      return "blue";
    case DarwinToolType.ADD_NUMBERS:
      return "green";
    default:
      return "gray";
  }
};

export const usageExample = `You are {{agent_name}}, a specialized AI agent for {{agent_description}}.

Your objective is to {{objective}}.

Today's date: {{DATE}}
Company: {{COMPANY_NAME}}

{% if plan_name %}
Working with plan: {{plan_name}}
Description: {{plan_description}}
{% endif %}

{% if MKG_INFO %}
Metric Knowledge Graph Information:
{{MKG_INFO}}
{% endif %}

{% if ANALYSIS_TREES %}
Analysis Trees:
{{ANALYSIS_TREES}}
{% endif %}

Custom Instructions: {{custom_instructions}}
Key Issues to Address: {{key_issues}}`;
